var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusBadgeSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66 7.08L4.355 5.775C4.245 5.665 4.11 5.61 3.95 5.61C3.79 5.61 3.65 5.67 3.53 5.79C3.42 5.9 3.365 6.04 3.365 6.21C3.365 6.38 3.42 6.52 3.53 6.63L5.24 8.34C5.35 8.45 5.49 8.505 5.66 8.505C5.83 8.505 5.97 8.45 6.08 8.34L9.485 4.935C9.595 4.825 9.65 4.69 9.65 4.53C9.65 4.37 9.59 4.23 9.47 4.11C9.36 4 9.22 3.945 9.05 3.945C8.88 3.945 8.74 4 8.63 4.11L5.66 7.08ZM6.5 12C5.67 12 4.89 11.8424 4.16 11.5272C3.43 11.2124 2.795 10.785 2.255 10.245C1.715 9.705 1.2876 9.07 0.9728 8.34C0.6576 7.61 0.5 6.83 0.5 6C0.5 5.17 0.6576 4.39 0.9728 3.66C1.2876 2.93 1.715 2.295 2.255 1.755C2.795 1.215 3.43 0.7874 4.16 0.4722C4.89 0.1574 5.67 0 6.5 0C7.33 0 8.11 0.1574 8.84 0.4722C9.57 0.7874 10.205 1.215 10.745 1.755C11.285 2.295 11.7124 2.93 12.0272 3.66C12.3424 4.39 12.5 5.17 12.5 6C12.5 6.83 12.3424 7.61 12.0272 8.34C11.7124 9.07 11.285 9.705 10.745 10.245C10.205 10.785 9.57 11.2124 8.84 11.5272C8.11 11.8424 7.33 12 6.5 12Z",
    fill: "#1A202C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusBadgeSuccess);
export default __webpack_public_path__ + "static/media/StatusBadgeSuccess.8e242660d36e151fe70cd05c872bf67c.svg";
export { ForwardRef as ReactComponent };